// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_d3-b";
export var colorBlue = "_d3-8";
export var colorDot = "_d3-0";
export var colorDotLarge = "_d3-2";
export var colorDotSmall = "_d3-1";
export var colorGreen = "_d3-7";
export var colorGrey = "_d3-3";
export var colorOrange = "_d3-5";
export var colorPink = "_d3-a";
export var colorPurple = "_d3-9";
export var colorRed = "_d3-4";
export var colorYellow = "_d3-6";